export const cities = [
	{
		id: 65,

		states: [
			{
				id: 3235,
				cities: [
					{
						id: 149594,
						name: "Abu Qir",
						latitude: "31.31666667",
						longitude: "30.06666667",
					},
					{
						id: 149595,
						name: "Agami",
						latitude: "31.09590000",
						longitude: "29.76040000",
					},
					{
						id: 31787,
						name: "Alexandria",
						latitude: "31.20176000",
						longitude: "29.91582000",
					},
					{
						id: 149596,
						name: "Ar-Raml",
						latitude: "31.24821000",
						longitude: "29.97368000",
					},
					{
						id: 149597,
						name: "Borg El Arab",
						latitude: "30.91666667",
						longitude: "29.53333333",
					},
					{
						id: 149598,
						name: "Montaza",
						latitude: "31.28270000",
						longitude: "30.02190000",
					},
					{
						id: 149599,
						name: "New Borg El Arab",
						latitude: "30.88525000",
						longitude: "29.57721000",
					},
					{
						id: 149600,
						name: "Sidi Bishr",
						latitude: "31.25210000",
						longitude: "29.99450000",
					},
				],
			},
			{
				id: 3225,
				cities: [
					{
						id: 31756,
						name: "Abu Simbel",
						latitude: "22.34570000",
						longitude: "31.61624000",
					},
					{
						id: 31791,
						name: "Aswan",
						latitude: "24.09082000",
						longitude: "32.89942000",
					},
					{
						id: 31819,
						name: "Idfū",
						latitude: "24.97916000",
						longitude: "32.87722000",
					},
					{
						id: 31829,
						name: "Kawm Umbū",
						latitude: "24.47669000",
						longitude: "32.94626000",
					},
				],
			},
			{
				id: 3236,
				cities: [
					{
						id: 31755,
						name: "Abnūb",
						latitude: "27.26960000",
						longitude: "31.15105000",
					},
					{
						id: 31758,
						name: "Abū Tīj",
						latitude: "27.04411000",
						longitude: "31.31897000",
					},
					{
						id: 31764,
						name: "Al Badārī",
						latitude: "26.99257000",
						longitude: "31.41554000",
					},
					{
						id: 31781,
						name: "Al Qūşīyah",
						latitude: "27.44020000",
						longitude: "30.81841000",
					},
					{
						id: 31792,
						name: "Asyūţ",
						latitude: "27.18096000",
						longitude: "31.18368000",
					},
					{
						id: 31807,
						name: "Dayrūţ",
						latitude: "27.55602000",
						longitude: "30.80764000",
					},
					{
						id: 31836,
						name: "Manfalūţ",
						latitude: "27.31040000",
						longitude: "30.97004000",
					},
				],
			},
			{
				id: 3241,
				cities: [
					{
						id: 31759,
						name: "Abū al Maţāmīr",
						latitude: "30.91018000",
						longitude: "30.17438000",
					},
					{
						id: 31760,
						name: "Ad Dilinjāt",
						latitude: "30.82796000",
						longitude: "30.53552000",
					},
					{
						id: 31804,
						name: "Damanhūr",
						latitude: "31.03408000",
						longitude: "30.46823000",
					},
					{
						id: 31879,
						name: "Ḩawsh ‘Īsá",
						latitude: "30.91280000",
						longitude: "30.29019000",
					},
					{
						id: 31820,
						name: "Idkū",
						latitude: "31.30730000",
						longitude: "30.29810000",
					},
					{
						id: 31826,
						name: "Kafr ad Dawwār",
						latitude: "31.13379000",
						longitude: "30.12969000",
					},
					{
						id: 31830,
						name: "Kawm Ḩamādah",
						latitude: "30.76128000",
						longitude: "30.69972000",
					},
					{
						id: 31857,
						name: "Rosetta",
						latitude: "31.39951000",
						longitude: "30.41718000",
					},
				],
			},
			{
				id: 3230,
				cities: [
					{
						id: 31768,
						name: "Al Fashn",
						latitude: "28.82431000",
						longitude: "30.89948000",
					},
					{
						id: 31798,
						name: "Banī Suwayf",
						latitude: "29.07441000",
						longitude: "31.09785000",
					},
					{
						id: 31801,
						name: "Būsh",
						latitude: "29.14816000",
						longitude: "31.12733000",
					},
					{
						id: 31869,
						name: "Sumusţā as Sulţānī",
						latitude: "28.91667000",
						longitude: "30.85000000",
					},
				],
			},
			{
				id: 3223,
				cities: [
					{
						id: 149582,
						name: "Badr",
						latitude: "30.13600000",
						longitude: "31.71500000",
					},
					{
						id: 149583,
						name: "Bulaq",
						latitude: "30.05300000",
						longitude: "31.23000000",
					},
					{
						id: 31802,
						name: "Cairo",
						latitude: "30.06263000",
						longitude: "31.24967000",
					},
					{
						id: 149584,
						name: "El Mataria",
						latitude: "30.12950000",
						longitude: "31.28890000",
					},
					{
						id: 149585,
						name: "Fustat",
						latitude: "30.00000000",
						longitude: "31.23333333",
					},
					{
						id: 149586,
						name: "Hadayek El Kobba",
						latitude: "30.09670000",
						longitude: "31.31030000",
					},
					{
						id: 149587,
						name: "Heliopolis",
						latitude: "30.13333333",
						longitude: "31.30000000",
					},
					{
						id: 149588,
						name: "Helwan",
						latitude: "29.84194444",
						longitude: "31.33416667",
					},
					{
						id: 149589,
						name: "Maadi",
						latitude: "29.96670000",
						longitude: "31.25000000",
					},
					{
						id: 149590,
						name: "Musturud",
						latitude: "30.13881944",
						longitude: "31.29241111",
					},
					{
						id: 149591,
						name: "New Administrative Capital of Egypt",
						latitude: "30.02750000",
						longitude: "31.76500000",
					},
					{
						id: 149592,
						name: "Shubra",
						latitude: "30.07250000",
						longitude: "31.24080000",
					},
					{
						id: 149593,
						name: "Tura",
						latitude: "29.93927900",
						longitude: "31.29000700",
					},
					{
						id: 149594,
						name: "Nasr City",
						latitude: "30.05610000",
						longitude: "31.33000000",
					},
					{
						id: 149595,
						name: "El Obour",
						latitude: "30.22220000",
						longitude: "31.45830000",
					},
					{
						id: 149596,
						name: "Ain Shams",
						latitude: "30.12350000",
						longitude: "31.33020000",
					},
					{
						id: 149597,
						name: "El Marg",
						latitude: "30.15220000",
						longitude: "31.35400000",
					},
					{
						id: 149598,
						name: "El Salam City",
						latitude: "30.18000000",
						longitude: "31.42000000",
					},
					{
						id: 149599,
						name: "El Shorouk City",
						latitude: "30.14230000",
						longitude: "31.60500000",
					},
					{
						id: 149600,
						name: "Fifth Settlement",
						latitude: "30.01700000",
						longitude: "31.44200000",
					},
					{
						id: 149601,
						name: "El Zahraa",
						latitude: "30.02580000",
						longitude: "31.27860000",
					},
					{
						id: 149602,
						name: "El Sayeda Zeinab",
						latitude: "30.02880000",
						longitude: "31.23110000",
					},
					{
						id: 149603,
						name: "Abbassia",
						latitude: "30.06670000",
						longitude: "31.28330000",
					},
					{
						id: 149604,
						name: "El Zaytoun",
						latitude: "30.10900000",
						longitude: "31.29800000",
					},
					{
						id: 149605,
						name: "Hadayek El Zaitoun",
						latitude: "30.10180000",
						longitude: "31.29110000",
					},
					{
						id: 149606,
						name: "El Mokattam",
						latitude: "30.01690000",
						longitude: "31.34020000",
					},
					{
						id: 149607,
						name: "El Darb El Ahmar",
						latitude: "30.03840000",
						longitude: "31.25790000",
					},
					{
						id: 149608,
						name: "Bab El Louk",
						latitude: "30.04250000",
						longitude: "31.23560000",
					},
					{
						id: 149609,
						name: "Garden City",
						latitude: "30.03300000",
						longitude: "31.23300000",
					},
					{
						id: 149610,
						name: "El Sayeda Aisha",
						latitude: "30.02470000",
						longitude: "31.25420000",
					},
					{
						id: 149611,
						name: "Masr El Gedida",
						latitude: "30.12100000",
						longitude: "31.33800000",
					},
					{
						id: 149612,
						name: "Rod El Farag",
						latitude: "30.06940000",
						longitude: "31.22690000",
					},
					{
						id: 149613,
						name: "Zamalek",
						latitude: "30.06670000",
						longitude: "31.21670000",
					},
				],
			},
			{
				id: 3245,
				cities: [
					{
						id: 31880,
						name: "‘Izbat al Burj",
						latitude: "31.50840000",
						longitude: "31.84106000",
					},
					{
						id: 31762,
						name: "Ajā",
						latitude: "30.94162000",
						longitude: "31.29039000",
					},
					{
						id: 31770,
						name: "Al Jammālīyah",
						latitude: "31.18065000",
						longitude: "31.86497000",
					},
					{
						id: 31775,
						name: "Al Manşūrah",
						latitude: "31.03637000",
						longitude: "31.38069000",
					},
					{
						id: 31774,
						name: "Al Manzalah",
						latitude: "31.15823000",
						longitude: "31.93600000",
					},
					{
						id: 31776,
						name: "Al Maţarīyah",
						latitude: "31.18287000",
						longitude: "32.03108000",
					},
					{
						id: 31800,
						name: "Bilqās",
						latitude: "31.21452000",
						longitude: "31.35798000",
					},
					{
						id: 31808,
						name: "Dikirnis",
						latitude: "31.08898000",
						longitude: "31.59478000",
					},
					{
						id: 31844,
						name: "Minyat an Naşr",
						latitude: "31.12624000",
						longitude: "31.64313000",
					},
					{
						id: 31865,
						name: "Shirbīn",
						latitude: "31.19688000",
						longitude: "31.52430000",
					},
					{
						id: 31876,
						name: "Ţalkhā",
						latitude: "31.05390000",
						longitude: "31.37787000",
					},
				],
			},
			{
				id: 3224,
				cities: [
					{
						id: 31794,
						name: "Az Zarqā",
						latitude: "31.20864000",
						longitude: "31.63528000",
					},
					{
						id: 31805,
						name: "Damietta",
						latitude: "31.41648000",
						longitude: "31.81332000",
					},
					{
						id: 31815,
						name: "Fāraskūr",
						latitude: "31.32977000",
						longitude: "31.71507000",
					},
				],
			},
			{
				id: 3238,
				cities: [
					{
						id: 31769,
						name: "Al Fayyūm",
						latitude: "29.30995000",
						longitude: "30.84180000",
					},
					{
						id: 31782,
						name: "Al Wāsiţah",
						latitude: "29.33778000",
						longitude: "31.20556000",
					},
					{
						id: 31818,
						name: "Ibshawāy",
						latitude: "29.35896000",
						longitude: "30.68061000",
					},
					{
						id: 31823,
						name: "Iţsā",
						latitude: "29.23760000",
						longitude: "30.78944000",
					},
					{
						id: 31877,
						name: "Ţāmiyah",
						latitude: "29.47639000",
						longitude: "30.96119000",
					},
				],
			},
			{
				id: 3234,
				cities: [
					{
						id: 31777,
						name: "Al Maḩallah al Kubrá",
						latitude: "30.97063000",
						longitude: "31.16690000",
					},
					{
						id: 31799,
						name: "Basyūn",
						latitude: "30.93976000",
						longitude: "30.81338000",
					},
					{
						id: 31828,
						name: "Kafr az Zayyāt",
						latitude: "30.82480000",
						longitude: "30.81805000",
					},
					{
						id: 31855,
						name: "Quţūr",
						latitude: "30.97225000",
						longitude: "30.95614000",
					},
					{
						id: 31860,
						name: "Samannūd",
						latitude: "30.96160000",
						longitude: "31.24069000",
					},
					{
						id: 31872,
						name: "Tanda",
						latitude: "30.78847000",
						longitude: "31.00192000",
					},
					{
						id: 31874,
						name: "Zefta",
						latitude: "30.71420000",
						longitude: "31.24425000",
					},
				],
			},
			{
				id: 3239,
				cities: [
					{
						id: 31786,
						name: "Al ‘Ayyāţ",
						latitude: "29.61972000",
						longitude: "31.25750000",
					},
					{
						id: 31766,
						name: "Al Bawīţī",
						latitude: "28.34919000",
						longitude: "28.86591000",
					},
					{
						id: 31783,
						name: "Al Ḩawāmidīyah",
						latitude: "29.90000000",
						longitude: "31.25000000",
					},
					{
						id: 31795,
						name: "Aş Şaff",
						latitude: "29.56472000",
						longitude: "31.28111000",
					},
					{
						id: 31793,
						name: "Awsīm",
						latitude: "30.12303000",
						longitude: "31.13571000",
					},
					{
						id: 31816,
						name: "Giza",
						latitude: "30.00808000",
						longitude: "31.21093000",
					},
					{
						id: 31833,
						name: "Madīnat Sittah Uktūbar",
						latitude: "29.81667000",
						longitude: "31.05000000",
					}, // ✅ Add these inside the same cities array
					{
						id: 40006,
						name: "Dokki",
						latitude: "30.03800000",
						longitude: "31.21000000",
					},
					{
						id: 40007,
						name: "Mohandessin",
						latitude: "30.05350000",
						longitude: "31.20190000",
					},
					{
						id: 40008,
						name: "Haram",
						latitude: "29.99390000",
						longitude: "31.15850000",
					},
					{
						id: 40009,
						name: "Boulaq Ad Dakrour",
						latitude: "30.01710000",
						longitude: "31.18380000",
					},
					{
						id: 40010,
						name: "Warraq",
						latitude: "30.11390000",
						longitude: "31.20800000",
					},
					{
						id: 40011,
						name: "Talbia",
						latitude: "29.98490000",
						longitude: "31.16330000",
					},
					{
						id: 40012,
						name: "Saft El Laban",
						latitude: "29.98050000",
						longitude: "31.16370000",
					},
					{
						id: 40002,
						name: "Hadayek Al Ahram",
						latitude: "29.98560000",
						longitude: "31.11320000",
					},
					{
						id: 40003,
						name: "Faisal",
						latitude: "29.99620000",
						longitude: "31.16170000",
					},
					{
						id: 40004,
						name: "El Monib",
						latitude: "29.98150000",
						longitude: "31.20830000",
					},
					{
						id: 40005,
						name: "El Behous",
						latitude: "30.01320000",
						longitude: "31.20080000",
					},
				],
			},
			{
				id: 3244,
				cities: [
					{
						id: 31821,
						name: "Ismailia",
						latitude: "30.60427000",
						longitude: "32.27225000",
					},
				],
			},
			{
				id: 3222,
				cities: [
					{
						id: 31784,
						name: "Al Ḩāmūl",
						latitude: "31.31146000",
						longitude: "31.14766000",
					},
					{
						id: 31810,
						name: "Disūq",
						latitude: "31.13259000",
						longitude: "30.64784000",
					},
					{
						id: 31814,
						name: "Fuwwah",
						latitude: "31.20365000",
						longitude: "30.54908000",
					},
					{
						id: 31827,
						name: "Kafr ash Shaykh",
						latitude: "31.11174000",
						longitude: "30.93991000",
					},
					{
						id: 31837,
						name: "Markaz Disūq",
						latitude: "31.14590000",
						longitude: "30.71609000",
					},
					{
						id: 31845,
						name: "Munshāt ‘Alī Āghā",
						latitude: "31.15791000",
						longitude: "30.70177000",
					},
					{
						id: 31870,
						name: "Sīdī Sālim",
						latitude: "31.27133000",
						longitude: "30.78617000",
					},
				],
			},
			{
				id: 3242,
				cities: [
					{
						id: 31832,
						name: "Luxor",
						latitude: "25.69893000",
						longitude: "32.64210000",
					},
					{
						id: 31840,
						name: "Markaz al Uqşur",
						latitude: "25.62986000",
						longitude: "32.59017000",
					},
				],
			},
			{
				id: 3231,
				cities: [
					{
						id: 31785,
						name: "Al ‘Alamayn",
						latitude: "30.83007000",
						longitude: "28.95502000",
					},
					{
						id: 31843,
						name: "Mersa Matruh",
						latitude: "31.35290000",
						longitude: "27.23725000",
					},
					{
						id: 31866,
						name: "Siwa Oasis",
						latitude: "29.20320000",
						longitude: "25.51965000",
					},
				],
			},
			{
				id: 3243,
				cities: [
					{
						id: 31757,
						name: "Abū Qurqāş",
						latitude: "27.93120000",
						longitude: "30.83841000",
					},
					{
						id: 31778,
						name: "Al Minyā",
						latitude: "28.10988000",
						longitude: "30.75030000",
					},
					{
						id: 31797,
						name: "Banī Mazār",
						latitude: "28.50360000",
						longitude: "30.80040000",
					},
					{
						id: 31806,
						name: "Dayr Mawās",
						latitude: "27.64176000",
						longitude: "30.84662000",
					},
					{
						id: 31835,
						name: "Mallawī",
						latitude: "27.73140000",
						longitude: "30.84165000",
					},
					{
						id: 31842,
						name: "Maţāy",
						latitude: "28.41899000",
						longitude: "30.77924000",
					},
					{
						id: 31861,
						name: "Samālūţ",
						latitude: "28.31214000",
						longitude: "30.71007000",
					},
				],
			},
			{
				id: 3228,
				cities: [
					{
						id: 31767,
						name: "Al Bājūr",
						latitude: "30.43046000",
						longitude: "31.03679000",
					},
					{
						id: 31789,
						name: "Ash Shuhadā’",
						latitude: "30.59683000",
						longitude: "30.89931000",
					},
					{
						id: 31790,
						name: "Ashmūn",
						latitude: "30.29735000",
						longitude: "30.97641000",
					},
					{
						id: 31846,
						name: "Munūf",
						latitude: "30.46597000",
						longitude: "30.93199000",
					},
					{
						id: 31854,
						name: "Quwaysinā",
						latitude: "30.56482000",
						longitude: "31.15777000",
					},
					{
						id: 31863,
						name: "Shibīn al Kawm",
						latitude: "30.55258000",
						longitude: "31.00904000",
					},
					{
						id: 31871,
						name: "Talā",
						latitude: "30.67980000",
						longitude: "30.94364000",
					},
				],
			},
			{
				id: 3246,
				cities: [
					{
						id: 31772,
						name: "Al Khārijah",
						latitude: "25.45141000",
						longitude: "30.54635000",
					},
					{
						id: 31852,
						name: "Qaşr al Farāfirah",
						latitude: "27.05680000",
						longitude: "27.96979000",
					},
				],
			},
			{
				id: 3227,
				cities: [
					{
						id: 31788,
						name: "Arish",
						latitude: "31.13159000",
						longitude: "33.79844000",
					},
				],
			},
			{
				id: 3229,
				cities: [
					{
						id: 31850,
						name: "Port Said",
						latitude: "31.25654000",
						longitude: "32.28411000",
					},
				],
			},
			{
				id: 3232,
				cities: [
					{
						id: 31771,
						name: "Al Khānkah",
						latitude: "30.21035000",
						longitude: "31.36812000",
					},
					{
						id: 31779,
						name: "Al Qanāţir al Khayrīyah",
						latitude: "30.19327000",
						longitude: "31.13703000",
					},
					{
						id: 31796,
						name: "Banhā",
						latitude: "30.45977000",
						longitude: "31.18420000",
					},
					{
						id: 31851,
						name: "Qalyūb",
						latitude: "30.17922000",
						longitude: "31.20560000",
					},
					{
						id: 31864,
						name: "Shibīn al Qanāṭir",
						latitude: "30.31269000",
						longitude: "31.32018000",
					},
					{
						id: 31873,
						name: "Toukh",
						latitude: "30.35487000",
						longitude: "31.20105000",
					},
				],
			},
			{
				id: 3247,
				cities: [
					{
						id: 31809,
						name: "Dishnā",
						latitude: "26.12467000",
						longitude: "32.47598000",
					},
					{
						id: 31813,
						name: "Farshūţ",
						latitude: "26.05494000",
						longitude: "32.16329000",
					},
					{
						id: 31822,
						name: "Isnā",
						latitude: "25.29336000",
						longitude: "32.55402000",
					},
					{
						id: 31831,
						name: "Kousa",
						latitude: "25.91407000",
						longitude: "32.76362000",
					},
					{
						id: 31847,
						name: "Naja' Ḥammādī",
						latitude: "26.04949000",
						longitude: "32.24142000",
					},
					{
						id: 31853,
						name: "Qinā",
						latitude: "26.16418000",
						longitude: "32.72671000",
					},
				],
			},
			{
				id: 3240,
				cities: [
					{
						id: 31780,
						name: "Al Quşayr",
						latitude: "26.10426000",
						longitude: "34.27793000",
					},
					{
						id: 31811,
						name: "El Gouna",
						latitude: "27.39417000",
						longitude: "33.67825000",
					},
					{
						id: 31817,
						name: "Hurghada",
						latitude: "27.25738000",
						longitude: "33.81291000",
					},
					{
						id: 31834,
						name: "Makadi Bay",
						latitude: "26.99123000",
						longitude: "33.89952000",
					},
					{
						id: 31841,
						name: "Marsa Alam",
						latitude: "25.06305000",
						longitude: "34.89005000",
					},
					{
						id: 31856,
						name: "Ras Gharib",
						latitude: "28.35831000",
						longitude: "33.07829000",
					},
					{
						id: 31858,
						name: "Safaga",
						latitude: "26.74906000",
						longitude: "33.93891000",
					},
				],
			},
			{
				id: 5067,
				cities: [
					{
						id: 149220,
						name: "10th of Ramadan",
						latitude: "30.29939390",
						longitude: "31.61417890",
					},
					{
						id: 149228,
						name: "Al Qurein",
						latitude: "26.29300660",
						longitude: "31.84950350",
					},
					{
						id: 149223,
						name: "Awlad Saqr",
						latitude: "30.93096230",
						longitude: "31.69132380",
					},
					{
						id: 149224,
						name: "Bilbeis",
						latitude: "30.41676920",
						longitude: "31.55430480",
					},
					{
						id: 149225,
						name: "Diyarb Negm",
						latitude: "30.74800820",
						longitude: "31.38893080",
					},
					{
						id: 149226,
						name: "El Husseiniya",
						latitude: "31.13933960",
						longitude: "32.14949670",
					},
					{
						id: 149229,
						name: "Faqous",
						latitude: "30.72291740",
						longitude: "31.76136580",
					},
					{
						id: 149230,
						name: "Hihya",
						latitude: "30.65516210",
						longitude: "31.50671570",
					},
					{
						id: 149231,
						name: "Kafr Saqr",
						latitude: "30.77955140",
						longitude: "31.61774120",
					},
					{
						id: 149221,
						name: "Markaz Abū Ḩammād",
						latitude: "30.53604430",
						longitude: "31.65970230",
					},
					{
						id: 149232,
						name: "Mashtoul El Souk",
						latitude: "30.35570110",
						longitude: "31.36278530",
					},
					{
						id: 149233,
						name: "Minya El Qamh",
						latitude: "30.50037450",
						longitude: "31.23766850",
					},
					{
						id: 149234,
						name: "New Salhia",
						latitude: "30.62868790",
						longitude: "31.92099060",
					},
					{
						id: 149235,
						name: "Zagazig",
						latitude: "30.58456230",
						longitude: "31.34747790",
					},
				],
			},
			{
				id: 3226,
				cities: [
					{
						id: 31763,
						name: "Akhmīm",
						latitude: "26.56217000",
						longitude: "31.74503000",
					},
					{
						id: 31765,
						name: "Al Balyanā",
						latitude: "26.23568000",
						longitude: "32.00347000",
					},
					{
						id: 31773,
						name: "Al Manshāh",
						latitude: "26.47686000",
						longitude: "31.80350000",
					},
					{
						id: 31824,
						name: "Jirjā",
						latitude: "26.33826000",
						longitude: "31.89161000",
					},
					{
						id: 31825,
						name: "Juhaynah",
						latitude: "26.67319000",
						longitude: "31.49760000",
					},
					{
						id: 31838,
						name: "Markaz Jirjā",
						latitude: "26.30683000",
						longitude: "31.84574000",
					},
					{
						id: 31839,
						name: "Markaz Sūhāj",
						latitude: "26.53948000",
						longitude: "31.67524000",
					},
					{
						id: 31867,
						name: "Sohag",
						latitude: "26.55695000",
						longitude: "31.69478000",
					},
					{
						id: 31875,
						name: "Ţahţā",
						latitude: "26.76930000",
						longitude: "31.50214000",
					},
				],
			},
			{
				id: 3237,
				cities: [
					{
						id: 31803,
						name: "Dahab",
						latitude: "28.48208000",
						longitude: "34.49505000",
					},
					{
						id: 31812,
						name: "El-Tor",
						latitude: "28.24168000",
						longitude: "33.62220000",
					},
					{
						id: 31849,
						name: "Nuwaybi‘a",
						latitude: "29.04681000",
						longitude: "34.66340000",
					},
					{
						id: 31859,
						name: "Saint Catherine",
						latitude: "28.56191000",
						longitude: "33.94934000",
					},
					{
						id: 31862,
						name: "Sharm el-Sheikh",
						latitude: "27.91582000",
						longitude: "34.32995000",
					},
				],
			},
			{
				id: 3233,
				cities: [
					{
						id: 31761,
						name: "Ain Sukhna",
						latitude: "29.60018000",
						longitude: "32.31671000",
					},
					{
						id: 31868,
						name: "Suez",
						latitude: "29.97371000",
						longitude: "32.52627000",
					},
				],
			},
		],
	},
	{
		id: 194,
		states: [
			{
				id: 9401,
				cities: [
					{
						id: 940101,
						name: "Jazan",
						latitude: "16.88920000",
						longitude: "42.57000000",
					},
					{
						id: 940102,
						name: "Khamis Mushait",
						latitude: "18.30600000",
						longitude: "42.72900000",
					},
					{
						id: 940103,
						name: "Najran",
						latitude: "17.49330000",
						longitude: "44.13000000",
					},
				],
			},
			{
				id: 9402,
				cities: [
					{
						id: 940201,
						name: "Dammam",
						latitude: "26.42070000",
						longitude: "50.08880000",
					},
				],
			},
			{
				id: 9403,
				cities: [
					{
						id: 940301,
						name: "Tabuk",
						latitude: "28.38380000",
						longitude: "36.56620000",
					},
					{
						id: 940302,
						name: "Medina",
						latitude: "24.47090000",
						longitude: "39.61220000",
					},
				],
			},
			{
				id: 9404,
				cities: [
					{
						id: 940401,
						name: "Jeddah",
						latitude: "21.54280000",
						longitude: "39.19730000",
					},
					{
						id: 940402,
						name: "Mecca",
						latitude: "21.42250000",
						longitude: "39.82620000",
					},
				],
			},
			{
				id: 9405,
				cities: [
					{
						id: 940501,
						name: "Riyadh",
						latitude: "24.71360000",
						longitude: "46.67530000",
					},
					{
						id: 940502,
						name: "Qassim",
						latitude: "26.35950000",
						longitude: "43.98180000",
					},
				],
			},
		],
	},
];
